/**
 * Start app — /apps/start/*
 *
 * The suite's front door. One job: name what you're trying to do and land in
 * the right flow with everything reducible already decided. One screen
 * (C Mode maximum is four; Start needs one).
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import StartScreen from './StartScreen';

export default function StartApp() {
  const app = getAppDefinition('start')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<StartScreen />} />
        <Route path="*" element={<Navigate to="/apps/start" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
